// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"9abd6872","781":"78466a04"}[chunkId] + ".chunk.css";
};